/**
 * section-gozo-testimonials.js
 * Vanilla JS carousel for the GOZO Testimonials section.
 * Scoped to each section instance via data-section-id.
 * Supports: prev/next buttons, pagination dots (inside each card), touch swipe.
 * Respects prefers-reduced-motion (instant switch, no animation).
 * Safe with 0 or 1 slides.
 *
 * Dots live INSIDE each slide's card — multiple groups, one per slide.
 * All groups are synced to reflect the current slide on every goTo().
 */

(function () {
  'use strict';

  function initCarousel(carousel) {
    // Guard against double-init (hot-reload / repeated section:load events)
    if (carousel.dataset.carouselReady === '1') return;
    carousel.dataset.carouselReady = '1';

    var slides  = Array.from(carousel.querySelectorAll('[data-carousel-track] .testi__slide'));
    var prevBtn = carousel.querySelector('[data-carousel-prev]');
    var nextBtn = carousel.querySelector('[data-carousel-next]');

    if (slides.length <= 1) {
      // Hide arrow controls; a single dot group is fine to leave as-is
      if (prevBtn) prevBtn.style.display = 'none';
      if (nextBtn) nextBtn.style.display = 'none';
      return;
    }

    var current = 0;

    // All dot buttons across every card's .testi__dots group
    var allDots = Array.from(carousel.querySelectorAll('[data-carousel-dot]'));

    function goTo(index) {
      // Deactivate current slide
      slides[current].classList.remove('testi__slide--active');
      slides[current].removeAttribute('aria-current');
      slides[current].setAttribute('aria-hidden', 'true');

      // Update index (wrap around)
      current = (index + slides.length) % slides.length;

      // Activate new slide
      slides[current].classList.add('testi__slide--active');
      slides[current].setAttribute('aria-current', 'true');
      slides[current].removeAttribute('aria-hidden');

      // Sync ALL dot buttons across every card group
      allDots.forEach(function (dot) {
        var dotIndex = parseInt(dot.getAttribute('data-carousel-dot'), 10);
        if (dotIndex === current) {
          dot.classList.add('testi__dot--active');
          dot.setAttribute('aria-selected', 'true');
        } else {
          dot.classList.remove('testi__dot--active');
          dot.setAttribute('aria-selected', 'false');
        }
      });
    }

    // Prev / Next buttons
    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        goTo(current - 1);
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        goTo(current + 1);
      });
    }

    // Dot buttons — navigate to the dot's own index
    allDots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        goTo(parseInt(dot.getAttribute('data-carousel-dot'), 10));
      });
    });

    // Touch swipe support
    var touchStartX = null;
    var touchStartY = null;
    var swipeThreshold = 40;

    carousel.addEventListener('touchstart', function (e) {
      touchStartX = e.touches[0].clientX;
      touchStartY = e.touches[0].clientY;
    }, { passive: true });

    carousel.addEventListener('touchend', function (e) {
      if (touchStartX === null) return;
      var dx = e.changedTouches[0].clientX - touchStartX;
      var dy = e.changedTouches[0].clientY - touchStartY;
      // Only trigger if horizontal swipe dominates
      if (Math.abs(dx) > Math.abs(dy) && Math.abs(dx) > swipeThreshold) {
        if (dx < 0) {
          goTo(current + 1);
        } else {
          goTo(current - 1);
        }
      }
      touchStartX = null;
      touchStartY = null;
    }, { passive: true });
  }

  function initAll() {
    var carousels = document.querySelectorAll('[data-testimonials-carousel]');
    carousels.forEach(function (carousel) {
      initCarousel(carousel);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Re-init when Shopify re-renders the section (theme editor + dev hot-reload),
  // which happens AFTER DOMContentLoaded so the initial pass never sees it.
  document.addEventListener('shopify:section:load', function (e) {
    var carousel = e.target.querySelector('[data-testimonials-carousel]');
    if (carousel) initCarousel(carousel);
  });
})();
